import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { userRoutes } from "./routes/AllRoutes";
import UserLayout from "./routes/middleware/UserLayout";
import AuthProvider from "./context/AuthContext";
import { Toaster } from "react-hot-toast";
import ScrollToTopButton from "./components/common/ScrollToTopButton";
import DemoBookingAssistant from "./components/User/Chatbot/Demobookingassistant";
import AlertModal from "./components/common/AlertModal";
import CookieConsent from "./components/common/CookieConsent";

const App = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // check if modal already shown before
    const hasSeenModal = localStorage.getItem("alertModalShown");

    if (!hasSeenModal) {
      const t = setTimeout(() => {
        setShowModal(true);

        // save flag in localStorage
        localStorage.setItem("alertModalShown", "true");
      }, 400);

      return () => clearTimeout(t);
    }
  }, []);

  const renderUserRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={<UserLayout>{route.component}</UserLayout>}
      />
    ));
  };

  return (
    <React.Fragment>
      <BrowserRouter>
        <AuthProvider>
          <div>
            <Routes>{renderUserRoutes(userRoutes)}</Routes>
            <Toaster></Toaster>
          </div>
        </AuthProvider>
      </BrowserRouter>
      <div>
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-orange-500 hover:bg-orange-700 text-white shadow-xl flex items-center justify-center transition-all duration-200 active:scale-95"
          aria-label="Toggle chat"
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
          </svg>
        </button>
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {isOpen && (
        <DemoBookingAssistant
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          autoStart={true}
        />
      )}
      {showModal && <AlertModal onClose={() => setShowModal(false)} />}
      <CookieConsent />
    </React.Fragment>
  );
};

export default App;
